import $ from '@rover/globals/jquery';
import Backbone from '@rover/globals/backbone';
import Rover from '@rover/globals/Rover';
import StickySidebar from 'sticky-sidebar';
import _ from '@rover/globals/underscore';
import currentUser from '@rover/globals/currentUser';
import dataLayer from '@rover/globals/dataLayer';
import inject from '@rover/utilities/injector';

/* Models */
import AdvancedFilteringData from '../backbone/models/search/advanced_filtering_data';
import MapConfig from '../backbone/models/search/map_config';
import MapSearchData from '../backbone/models/search/map_search_data';
import ProxyModel from '../backbone/models/search/proxy_model';
import Query from '../backbone/models/search/query';
import SearchResults from '../backbone/models/search/search_results';
import SearchResultsQueue from '../backbone/models/search/search_results_queue';

/* Views */
import FavoriteToggleChannelView from '../pages/favorite_toggle_channel';
import EventTracker from '../backbone/views/search/event_tracker';
import SearchPageView from '../backbone/views/search/search_page_view';
import CitySearchHeaderView from '../backbone/views/search/city_search_header_view';
import PriceSliderView from '../backbone/views/price_slider_view';
import BasicFiltersLayoutManager from '../backbone/views/search/basic_filters_layout_manager';
import SpacesRequiredView from '../backbone/views/spaces_required_view';
import SearchAutofillLocationView from '../backbone/views/search/search_autofill_location_view';
import SearchSidebarFiltersView from '../backbone/views/search/search_sidebar_filters_view';
import SearchLocationView from '../backbone/views/search/search_location_view';
import SearchTypeView from '../backbone/views/search/search_type_view';
import FixedSearchFiltersButtonView from '../backbone/views/search/fixed_search_filters_button_view';
import DatePickerView from '../backbone/views/date_picker_view';
import DayOfTheWeekPickerView from '../backbone/views/day_of_the_week_picker_view';
import DaytimeAvailabilitySelectionView from '../backbone/views/daytime_availability_selection_view';
import FulltimeAvailabilitySelectionView from '../backbone/views/fulltime_availability_selection_view';
import BreedSelectionView from '../backbone/views/search/breed_selection_view';
import DogSizesView from '../backbone/views/search/dog_sizes_view';
import DogSelectionView from '../backbone/views/dog_selection_view';
import MobileAdvancedSearchFiltersView from '../backbone/views/search/mobile_advanced_search_filters_view';
import MobileSearchFiltersModalView from '../backbone/views/mobile_search_filters_modal_view';
import SearchResultsView from '../backbone/views/search/search_results_view';
import SearchResultsPaginationView from '../backbone/views/search/search_results_pagination_view';
import SearchMapView from '../backbone/views/search/search_map_view';
import RedoSearchInMapView from '../backbone/views/search/redo_search_in_map_view';
import AdvancedFiltersView from '../backbone/views/search/advanced_filters_view';
import AdvancedFiltersBarView from '../backbone/views/search/advanced_filters_bar_view';
import AdvancedFiltersModalView from '../backbone/views/search/advanced_filters_modal_view';
import AgenciesModalView from '../backbone/views/search/agencies_modal_view';
import ProviderGroupsModalView from '../backbone/views/search/provider_groups_modal_view';
import EmailCapturePopupView from '../backbone/views/email_capture_popup_view';
import MapSizeView from '../backbone/views/search/map_size_view';
import SearchWizardModal from '../backbone/views/search/search_wizard_modal';
import QuickMatchRecoveryModal from '../backbone/views/search/quick_match_recovery_modal';

/* Router */
import SearchRouter from '../backbone/routers/search_router';

/* Utilities */
import GeoLocation from '../utilities/GeoLocation';
import HistoryManager from '../backbone/utilities/search/history_manager';

/* Stickit Handlers */
import addBtnGroupRadioStickIt from '../backbone/utilities/add_btn_group_radio_stickit';
import addBtnGroupCheckboxStickIt from '../backbone/utilities/add_btn_group_checkbox_stickit';
import addDaterangepickerStickitHandler from '../backbone/utilities/add_daterange_picker_stickit_handler';

$(() => {
  if (!$('body').hasClass('js-search-page')) {
    return;
  }

  Rover.pubSub = Rover.pubSub || _.extend({}, Backbone.Events);

  const onGeolocationSuccess = (lat, lng, name) => {
    const view = Rover.views.searchLocationMobileView;
    if (view) {
      if (!view.getLocation()) {
        Rover.query.set({
          ...view.getSearchParamsFor(lat, lng),
          location: name,
          location_type: 'html5',
        });
      }
    }
  };

  const init = () => {
    const searchedQuery = Rover.searchResultsJson.query || {};
    const query = new Query(searchedQuery);
    Rover.query = query;
    const mobileModalQuery = new ProxyModel({ source: query });
    const searchResults = new SearchResults(Rover.searchResultsJson);
    Rover.searchResults = searchResults;

    const advancedFilteringData = new AdvancedFilteringData({});
    Rover.advancedFilteringData = advancedFilteringData;

    Rover.views = Rover.views || {};

    addBtnGroupCheckboxStickIt();
    addBtnGroupRadioStickIt();
    addDaterangepickerStickitHandler();

    dataLayer.push({ 'page-category': 'search' });
    Rover.views.eventTracker = new EventTracker({ searchResults });
    Rover.views.eventTracker.onInitialLoad(query);

    Rover.views.searchPageView = new SearchPageView({
      el: '.js-search-col-wrap',
    });

    Rover.views.citySearchHeaderView = new CitySearchHeaderView({
      el: '.js-city-search-header',
    });

    Rover.views.priceSliderView = new PriceSliderView({
      el: '.js-search-price-view-main',
      model: query,
      searchResults,
    });

    Rover.views.basicFiltersLayoutManager = new BasicFiltersLayoutManager({
      el: '.js-basic-filters',
    });

    Rover.views.spacesRequiredViewMain = new SpacesRequiredView({
      el: '.js-search-spaces-required-view-main',
      model: query,
      hasPets: Rover.context.hasPets,
    });

    Rover.views.spacesRequiredViewModal = new SpacesRequiredView({
      el: '.js-search-spaces-required-view-modal',
      model: mobileModalQuery,
      hasPets: Rover.context.hasPets,
    });

    Rover.searchResultsQueue = new SearchResultsQueue({
      query,
      searchResults,
      hasPets: Rover.context.hasPets,
    });

    /* eslint-disable no-new */
    new StickySidebar('.js-search-right-sidebar', {
      containerSelector: '.js-search-map-size-view',
      innerWrapperSelector: '.js-search-right-col-container',
    });
    if ($('.js-search-left-sidebar').length) {
      new SearchSidebarFiltersView({
        el: '.js-search-left-sidebar',
        model: query,
        filters: Rover.filtersByCategoryJson,
        serviceTypes: Rover.serviceTypesJson,
      });
      new StickySidebar('.js-search-left-sidebar', {
        containerSelector: '.js-search-map-size-view',
        innerWrapperSelector: '.js-sidebar-filters',
      });
    }
    if ($('.js-advanced-mobile-modal-filters').length) {
      new MobileAdvancedSearchFiltersView({
        el: '.js-advanced-mobile-modal-filters',
        model: mobileModalQuery,
        filters: Rover.filtersByCategoryJson,
        serviceTypes: Rover.serviceTypesJson,
      });
    }
    /* eslint-enable no-new */

    Rover.views.searchLocationView = new SearchLocationView({
      el: '.js-search-location-header-view',
      model: query,
      searchResults,
      isSearchEnabled: true,
      geoCodeWithoutPageRefresh: true,
    });

    Rover.views.searchLocationSidebarView = new SearchLocationView({
      el: '.js-search-location-sidebar-view',
      model: query,
      searchResults,
      isSearchEnabled: true,
      geoCodeWithoutPageRefresh: true,
    });

    Rover.views.searchLocationMobileView = new SearchLocationView({
      el: '.js-search-location-mobile-view',
      model: query,
      searchResults,
      isSearchEnabled: true,
    });

    Rover.views.fixedSearchFiltersButtonMobileView = new FixedSearchFiltersButtonView({
      el: '.js-show-filters-btn',
    });

    Rover.views.searchTypeView = new SearchTypeView({
      el: '.js-search-type-view-main',
      model: query,
    });

    Rover.views.datePickerView = new DatePickerView({
      el: '.js-search-section-when-main',
      query,
    });

    Rover.views.dayOfTheWeekPickerView = new DayOfTheWeekPickerView({
      el: '.js-search-section-days-main',
      model: query,
    });

    Rover.views.daytimeAvailabilitySelectionView = new DaytimeAvailabilitySelectionView({
      el: '.js-search-section-daytime-avail-top-main',
      model: query,
    });

    Rover.views.fulltimeAvailabilitySelectionView = new FulltimeAvailabilitySelectionView({
      el: '.js-search-section-fulltime-avail-top-main',
      model: query,
    });

    Rover.views.breedSelectionView = new BreedSelectionView({
      el: '.js-search-dog-breeds-view-main',
      model: query,
      pets: Rover.breedsJson,
    });

    Rover.views.dogSizesView = new DogSizesView({
      el: '.js-search-dog-sizes-view-main',
      model: query,
    });

    Rover.views.dogSelectionView = new DogSelectionView({
      el: '.js-search-dog-selection-view-main',
      model: query,
    });

    // Views for mobile non-modal search
    Rover.views.searchTypeViewMobile = new SearchTypeView({
      el: '.js-search-type-view-mobile',
      model: query,
    });

    Rover.views.datePickerViewMobile = new DatePickerView({
      el: '.js-search-section-when-mobile',
      query,
    });

    Rover.views.dayOfTheWeekPickerViewMobile = new DayOfTheWeekPickerView({
      el: '.js-search-section-days-mobile',
      model: query,
    });

    Rover.views.daytimeAvailabilitySelectionViewMobile = new DaytimeAvailabilitySelectionView({
      el: '.js-search-section-daytime-avail-top-mobile',
      model: query,
    });

    Rover.views.fulltimeAvailabilitySelectionViewMobile = new FulltimeAvailabilitySelectionView({
      el: '.js-search-section-fulltime-avail-top-mobile',
      model: query,
    });

    // Views for mobile search modals
    Rover.views.searchTypeViewModal = new SearchTypeView({
      el: '.js-search-type-view-modal',
      model: mobileModalQuery,
    });

    Rover.views.datePickerViewModal = new DatePickerView({
      el: '.js-search-section-when-modal',
      query: mobileModalQuery,
    });

    Rover.views.dayOfTheWeekPickerViewModal = new DayOfTheWeekPickerView({
      el: '.js-search-section-days-modal',
      model: mobileModalQuery,
    });

    Rover.views.daytimeAvailabilitySelectionViewModal = new DaytimeAvailabilitySelectionView({
      el: '.js-search-section-daytime-avail-top-modal',
      model: mobileModalQuery,
    });

    Rover.views.fulltimeAvailabilitySelectionViewModal = new FulltimeAvailabilitySelectionView({
      el: '.js-search-section-fulltime-avail-top-modal',
      model: mobileModalQuery,
    });

    Rover.views.priceSliderViewModal = new PriceSliderView({
      el: '.js-search-price-view-modal',
      model: mobileModalQuery,
      searchResults,
    });

    Rover.views.dogSizesView = new DogSizesView({
      el: '.js-search-dog-sizes-view-modal',
      model: mobileModalQuery,
    });

    Rover.views.dogSelectionViewModal = new DogSelectionView({
      el: '.js-search-dog-selection-view-modal',
      model: mobileModalQuery,
    });

    Rover.views.mobileSearchFiltersModal = new MobileSearchFiltersModalView({
      el: '.js-search-mobile-filters-modal-view',
      model: mobileModalQuery,
    });

    Rover.views.searchResultsView = new SearchResultsView({
      model: searchResults,
    });

    Rover.views.searchResultsPaginationView = new SearchResultsPaginationView({
      query,
      model: searchResults,
    });

    Rover.views.historyManager = new HistoryManager({
      query,
      searchResults,
      serviceTypes: Rover.serviceTypesJson,
    });

    // Create the FavoriteToggleChannelView once we know whether the user is anonymous
    const createFavoriteToggleChannelView = user => {
      Rover.views.favoriteToggleChannel = new FavoriteToggleChannelView({
        isAnonymous: !user.authenticated,
        loginUrl: Rover.urls.signin,
        source: 'search',
      });
    };

    currentUser.waitForUserLoaded().then(user => createFavoriteToggleChannelView(user));

    const mapSearchData = new MapSearchData();
    Rover.mapSearchData = mapSearchData;
    let mapSize = $.cookie('mapSize');

    if (!mapSize) {
      mapSize = 'small';
    }

    const mapConfig = new MapConfig({
      mapSize,
    });

    Rover.mapConfig = mapConfig;

    const $searchMapView = $('.js-search-map-view');
    Rover.views.searchMapView = new SearchMapView({
      el: $searchMapView,
      query,
      searchResults,
      mapSearchData,
      mapConfig,
    });
    Rover.views.searchMapView.render();

    Rover.views.redoSearchInMapView = new RedoSearchInMapView({
      el: '.js-search-map-redo-search-view',
      query,
      mapConfig,
      mapSearchData,
      searchResults,
    });

    Rover.views.advancedFiltersView = new AdvancedFiltersView({
      el: '.js-advanced-filters-view',
      model: query,
    });

    Rover.views.advancedFiltersBar = new AdvancedFiltersBarView({
      el: '.js-advanced-filters-bar',
      model: advancedFilteringData,
      query,
    });

    Rover.views.sitterInfoModal = new AdvancedFiltersModalView({
      el: '.js-sitter-info-modal',
      model: new ProxyModel({ source: query }),
      title: 'Advanced Filters - Sitter Info',
    });

    Rover.views.agenciesModal = new AgenciesModalView({
      el: '.js-agencies-modal',
      model: new ProxyModel({ source: query }),
      title: 'Advanced Filters - Agencies',
    });

    Rover.views.providerGroupsModal = new ProviderGroupsModalView({
      el: '.js-provider-groups-modal',
      model: new ProxyModel({ source: query }),
      title: 'Advanced Filters - Provider Groups',
    });

    Rover.views.staffOnlyModal = new AdvancedFiltersModalView({
      el: '.js-staff-only-modal',
      model: new ProxyModel({ source: query }),
      title: 'Advanced Filters - Staff Only',
    });

    Rover.views.servicesModal = new AdvancedFiltersModalView({
      el: '.js-services-modal',
      model: new ProxyModel({ source: query }),
      title: 'Advanced Filters - Services',
    });

    const openEmailCaptureModal = true;

    if (openEmailCaptureModal) {
      Rover.views.emailCapturePopupView = new EmailCapturePopupView({
        el: '.js-email-capture-modal',
      });
    }

    Rover.views.mapSize = new MapSizeView({
      model: mapConfig,
    });

    Rover.views.searchWizardModal = new SearchWizardModal({
      title: 'Find the Perfect Match',
      content: $('.search-wizard-modal'),
      disableCancel: false,
      animate: true,
      showFooter: true,
      okType: 'primary',
      cancelText: null,
      okFocus: false,
      okCloses: false,
      classes: null,
      attrs: null,
      padding: true,
      serviceTypes: Rover.serviceTypesJson,
      walkingConfiguration: Rover.context.walkingConfiguration,
    });

    Rover.views.quickMatchRecoveryModal = new QuickMatchRecoveryModal({
      model: searchResults,
    });

    Rover.searchRouter = new SearchRouter();

    Rover.searchRouter.on('route:quickView', servicePK => {
      Rover.pubSub.trigger(`sitterCard:show:${servicePK}`);
      Rover.pubSub.trigger('history:resetToRootUrl');
    });

    Backbone.history.start({
      pushState: true,
      hashChange: false,
      silent: false,
      root: Rover.searchRouter.getRoot(),
    });

    const useHtml5Geolocation = inject('Rover.context.useHtml5Geolocation', false);
    if (useHtml5Geolocation) {
      const searchLocation = $('.js-search-location').val();

      if (!searchLocation || !searchLocation.length) {
        GeoLocation.init(onGeolocationSuccess);
      }
    } else {
      // If we're not in the test variant use the geoIP-based
      // localization autofill which is not very accurate,
      // especially for 3G/4G/LTE networks Normally, if we
      // rollout the HTML5 localization globally, we should not
      // need this approach anymore
      Rover.views.searchAutofillLocationView = new SearchAutofillLocationView({
        el: '.js-search-location-header-view',
        query,
        model: searchResults,
      });
      Rover.views.searchAutofillLocationSidebarView = new SearchAutofillLocationView({
        el: '.js-search-location-sidebar-view',
        query,
        model: searchResults,
      });
    }

    $('body').on('click', '.js-switch-pitch-show-boarding', event => {
      event.preventDefault();
      Rover.query.set({ service_type: 'overnight-boarding' });
    });
  };

  init();

  $(document).ready(() => {
    window.util.async_image_loader.load();

    const shouldOpenModal = !Rover.query.isDateConstrained() && !Rover.query.isFromAmpSearch();

    if (shouldOpenModal) {
      Rover.views.searchWizardModal.open();
    }
  });
});



// WEBPACK FOOTER //
// ./js/pages/search.js